import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import debounce from "lodash/debounce";
import Grid from "@mui/material/Grid";
import { searchableSelectCheck } from "./searchable-select-check";

const SearchableSelectInput = ({
  valueSpec,
  onChange,
  onError,
  multiSelect = false,
  fetchValueSpec,
}) => {
  const [open, setOpen] = useState(false);
  const [specData, setSpecData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState("");
  const [selectedValue, setSelectedValue] = useState(multiSelect ? [] : "");
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setSelectedValue(valueSpec.value);
    setSpecData(valueSpec);
    refreshValueSpec();
    const err = checkValue(valueSpec.value, valueSpec);
    if (err) {
      setError(true);
      onError(true);
    }
    return () => {};
  }, [valueSpec]);

  const handleInputChange = (event, newValue) => {
    setInputText(newValue);
    if (fetchValueSpec) {
      const df = debounce(() => {
        refreshValueSpec();
      }, 1000);
      df();
    }
  };

  const refreshValueSpec = () => {
    if (fetchValueSpec) {
      fetchValueSpec(inputText)
        .then(vs => {
          const input = vs.value;
          if (input === inputText) {
            setSpecData(vs.valueSpec);
            setLoading(false);
          }
        })
        .catch(error => {
          console.error("Error fetching options:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const handleSelectChange = (event, newValue) => {
    const err = checkValue(newValue, specData);
    setSelectedValue(newValue);
    setError(err);
    onChange(newValue);
    onError(err);
  };

  const handleBlur = (event, newVal) => {
    // checkValue(inputText, specData);
  };

  const checkValue = (value, spec) => {
    if (multiSelect) {
      for (let i = 0; i < value.length; i++) {
        const err = !searchableSelectCheck(value[i], spec);
        if (err) {
          return err;
        }
      }
      return false;
    } else {
      const err = !searchableSelectCheck(value, spec);
      return err;
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Grid container spacing={1} direction="column">
        {valueSpec.name && (
          <Grid item xs>
            <Typography variant="h6">{valueSpec.name}</Typography>
          </Grid>
        )}
        <Grid item xs>
          <div style={{ width: "100%" }}>
            <Autocomplete
              multiple={multiSelect}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              options={specData ? specData.enums || [] : []}
              loading={loading}
              inputValue={inputText}
              onInputChange={handleInputChange}
              onChange={handleSelectChange}
              onBlur={handleBlur}
              value={selectedValue}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Select value"
                  variant="outlined"
                  error={error}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchableSelectInput;
